import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import hashCode from '../utils/hashCode';

/**
* This is a higher-order component to provide common
* functionalities for form elements
*/
import { jsx as _jsx } from "react/jsx-runtime";
const CommonFormComponent = /* #__PURE__*/Component => {
  function FormWrapper(_ref) {
    let {
      errorMessages,
      fakeLabel,
      hasFeedback,
      help,
      id,
      isPristine,
      isValid,
      label,
      labelClassName,
      layout,
      name,
      optional,
      rowClassName,
      rowLabel,
      validatePristine,
      value,
      ...rest
    } = _ref;
    const showErrors = () => {
      if (isPristine && !validatePristine) {
        return false;
      }
      return !isValid;
    };
    const generateId = id || name.split('[').join('_').replace(']', '') + hashCode(value);

    // Generate root element className
    const rootClasses = clsx({
      'has-error': showErrors(),
      'has-feedback': showErrors() && hasFeedback,
      row: layout === 'horizontal'
    }, 'form-group', rowClassName);

    // effort for combining reaxl-forms/Input with reaxl/Input, reaxl-forms/Checkbox with reaxl/Checkbox
    const formElementProps = {
      labelProps: {
        label: rowLabel ?? label,
        // If rowLabel is exist return rowLabel, if not return label
        optional,
        className: clsx({
          'col-sm-3': layout === 'horizontal',
          'text-size-200 margin-bottom-1': layout !== 'inside'
        }, 'control-label', labelClassName),
        htmlFor: generateId,
        fakeLabel
      },
      errors: errorMessages,
      hasFeedback,
      showErrors: showErrors(),
      layout,
      help
    };
    return /*#__PURE__*/_jsx(Component, {
      id: generateId,
      label: label,
      name: name,
      value: value,
      optional: optional,
      isValid: isValid,
      isPristine: isPristine,
      formElementProps: formElementProps,
      rootClasses: rootClasses,
      labelClassName: labelClassName,
      ...rest
    });
  }
  /*
  * FormWrapper using displayName as a defaultProps of wrapped component
  * The purpose is support for tests that find component by displayName
  */
  FormWrapper.displayName = `CommonFormComponent(${Component.displayName})`;
  return /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/_jsx(FormWrapper, {
    ...props,
    forwardedRef: ref
  }));
};
export default CommonFormComponent;